export default __webpack_public_path__ + "static/media/achievedobjective.8a276e25.svg";